import axios from 'axios'
import { ThunkAction } from 'store/types'
// import { AccountPayloadType } from 'ducks/estimates/types'
import { reduceParams } from 'utils/helpers'
import { history } from 'routes'
// import { handleErrorMessageAlert } from 'components/UI/Alert'
import * as actions from './actions'
import { startLoading, finishLoading } from '../loading/actions'
import {
  handleErrorMessageAlert,
  handleSuccessMessageAlert
} from '../../components/UI/Alert'

export const createEstimate = (estimate: object): ThunkAction => {
  return async dispatch => {
    dispatch(actions.createEstimateRequest())
    // @ts-ignore
    dispatch(startLoading())
    try {
      // const estimateAsd = {
      //   appointmentIdSet: [1],
      //   dependent: {
      //     dob: '2019-09-09T15:48:11.549Z',
      //     firstName: 'Ivan',
      //     gender: 'Ambiguous',
      //     lastName: 'Petrov',
      //     middleInitial: 'Ivanovich'
      //   },
      //   dependentSearch: true,

      //   dob: '2019-09-09T15:48:11.549Z',
      //   eligibilityDate: '2019-09-09T15:48:11.549Z',
      //   estimationType: 'OutPatient',
      //   firstName: 'Patient',
      //   gender: 'Ambiguous',
      //   insuranceCarrierId: 1,
      //   lastName: 'Noname',
      //   middleInitial: 'middleInitial',
      //   physicianId: 1,
      //   relationship: 'AuntOrUncle',
      //   serviceAreaId: 1,
      //   serviceAreaName: 0,
      //   memberId: '8'
      // }

      const estimateAsd = estimate

      /*

      // @ts-ignore
      if (estimate.dependent) {
        // @ts-ignore
        estimate.dependent = reduceParams(estimate.dependent)
      }


    // @ts-ignore
      estimate = reduceParams(estimate)
      // @ts-ignore
      estimate.dependentSearch = true
      // @ts-ignore
      estimate.insuranceCarrierId = 1
      // @ts-ignore
      estimate.eligibilityDate = moment().toISOString()
      // @ts-ignore
      estimate.appointmentIdSet = [estimate.appointmentIdSet]
      // @ts-ignore
      estimate.estimationType = 'OutPatientComplex'
      // @ts-ignore
      estimate.relationship = estimate.relationships

      // @ts-ignore
      estimate.dependent.dob = '2019-09-09T15:48:11.549Z'
      // @ts-ignore
      estimate.dob = '2019-09-09T15:48:11.549Z'

      // @ts-ignore
      estimate.dob = '2019-09-09T15:48:11.549Z'


      console.log('tempEstimate', reduceParams(estimate))
*/
      const resp = await axios.post('/onDemandEstimation', {
        ...reduceParams(estimateAsd)
      })

      const { id } = resp.data
      // const { email, phoneNumber, firstName, lastName } = estimate

      dispatch(
        // @ts-ignore
        actions.createEstimateSuccess(estimateAsd)
      )
      const isNew = true
      history.push(`/estimate/${id}/${isNew}`)
      // @ts-ignore
      dispatch(finishLoading())
    } catch (err) {
      dispatch(actions.createEstimateFail(err.response))
      // @ts-ignore
      dispatch(finishLoading())
    }
  }
}

export const fetchEstimates = (
  size?: number,
  page?: number,
  text?: string
): ThunkAction => {
  return async dispatch => {
    dispatch(actions.fetchEstimatesRequest())
    // @ts-ignore
    dispatch(startLoading())
    try {
      let resp
      if (text) {
        resp = await axios.get(
          `/onDemandEstimation?size=${size}&page=${page}&firstName=${text}&sort=id,desc`
        )
        console.log('fetchEstimates by text', resp)
      } else if (size && page) {
        resp = await axios.get(
          `/onDemandEstimation?size=${size}&page=${page}&sort=id,desc`
        )
        console.log('fetchEstimates by page', resp)
      } else if (size) {
        resp = await axios.get(`/onDemandEstimation?size=${size}&sort=id,desc`)
        console.log('fetchEstimates', resp)
      } else {
        resp = await axios.get('/onDemandEstimation?sort=id,desc')
      }

      dispatch(actions.fetchEstimatesSuccess(resp.data))
      // @ts-ignore
      dispatch(finishLoading())
    } catch (err) {
      dispatch(actions.fetchEstimatesFail(err.response))
      // @ts-ignore
      dispatch(finishLoading())
    }
  }
}

export const fecthEstimateById = (id: string): ThunkAction => {
  return async dispatch => {
    dispatch(actions.fetchEstimateRequest())
    try {
      const resp = await axios.get(`/onDemandEstimation/${id}`) // /api/users/{userId}/estimations `/onDemandEstimation/${id}`
      console.log('Suc', resp)

      dispatch(actions.fetchEstimateSuccess(resp.data))
    } catch (err) {
      console.log('Fai', err)
      handleErrorMessageAlert(
        err.response && err.response.data && err.response.data.errorMessage
      )
      dispatch(actions.fetchEstimateFail(err.response))
    }
  }
}

const getDataLink = (data: Blob, options?: any) => {
  const url = window.URL.createObjectURL(data)
  const link: any = document.createElement('a')
  link.href = url
  link.target = '_blank'
  if (options) {
    for (const prop in options) {
      link[prop] = options[prop]
    }
  }
  return link
}

const generatePDFReport = async (id: string, isAuthenticated?: boolean) => {
  // @ts-ignore
  const URL = isAuthenticated
    ? `/onDemandEstimation/${id}/generatePDFReport`
    : `/public/${id}/generatePDFReport`
  return await axios.get(URL, {
    responseType: 'blob',
    headers: {
      Accept: 'application/pdf'
    }
  })
  // isAuthenticated
  //   ? await axios.get(URL, {
  //       responseType: 'blob',
  //       headers: {
  //         Accept: 'application/pdf'
  //       }
  //     }) // api/public/{id}/generatePDFReport
  //   : await axios.get(URL, {
  //       responseType: 'blob',
  //       headers: {
  //         Accept: 'application/pdf'
  //       }
  //     })
}

export const downloadPDF = (
  id: string,
  isAuthenticated?: boolean
): ThunkAction => {
  return async dispatch => {
    dispatch(actions.getPDFRequest())
    try {
      const resp = await generatePDFReport(id, isAuthenticated)
      const link = getDataLink(resp.data, {
        download: 'estimate.pdf'
      })
      link.click()
      dispatch(actions.getPDFSuccess())
    } catch (err) {
      dispatch(actions.getPDFFail(err.response))
      console.log('err', err)
    }
  }
}

export const goToPDF = (id: string): ThunkAction => {
  return async (dispatch, getStore) => {
    const {
      auth: { isAuthenticated }
    } = getStore()
    dispatch(actions.getPDFRequest())
    try {
      const resp = await generatePDFReport(id, isAuthenticated)
      const link = getDataLink(resp.data)
      link.click()
      dispatch(actions.getPDFSuccess())
    } catch (err) {
      dispatch(actions.getPDFFail(err.response))
      console.log('err', err)
    }
  }
}

export const getPDFOnEmail = (id: string): ThunkAction => {
  return async (dispatch, getStore) => {
    dispatch(actions.getPDFOnEmailRequest())
    try {
      const {
        profile: {
          profile: { email }
        },
        auth: { publicEmail, isAuthenticated },
        estimates: { publicEstimate }
      } = getStore()
      const URL = isAuthenticated
        ? `/onDemandEstimation/${id}/generateEmailReport/${email}`
        : `/public/${publicEstimate.id}/generateEmailReport/${publicEmail}`
      const resp = await axios.get(URL)
      dispatch(actions.getPDFOnEmailSuccess(resp.data))
      handleSuccessMessageAlert('Your estimate sent successfully!')
    } catch (err) {
      dispatch(actions.getPDFOnEmailFail(err.response))
    }
  }
}

export const createPublicEstimate = (estimate: object): ThunkAction => {
  return async dispatch => {
    dispatch(actions.createPublicEstimateRequest())
    // @ts-ignore
    dispatch(startLoading())
    try {
      const estimateAsd = estimate
      const resp = await axios.post('/public', {
        ...reduceParams(estimateAsd)
      })
      console.log(resp)
      const { id } = resp.data
      dispatch(
        // @ts-ignore
        actions.createPublicEstimateSuccess(resp)
      )
      const isNew = true
      history.push(`/estimate/${id}/${isNew}`)
      // @ts-ignore
      dispatch(finishLoading())
    } catch (err) {
      dispatch(actions.createPublicEstimateFail(err.response))
      // @ts-ignore
      dispatch(finishLoading())
    }
  }
}
